export default "__VITE_ASSET__YGtoUym3__"